import {
  fetchGetOpenBankingProviders,
  GetOpenBankingProvidersResponse,
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { TOnlineBank } from '../../components/TradingHistory/OpenBanking/OpenBanking.types';
import { inferProvider } from '../../components/TradingHistory/OpenBanking/trueLayer.helpers';
export function useGetOpenBankingProviders({
  stateKey,
  token,
}: {
  stateKey?: string;
  token?: string;
}) {
  const {
    data: openBankingProviders,
    isLoading,
    isError,
  } = useQuery<GetOpenBankingProvidersResponse>({
    queryKey: ['getOpenBankingProviders', stateKey, token],
    queryFn: () =>
      fetchGetOpenBankingProviders({ stateKey: stateKey!, token: token! }),
    enabled: Boolean(stateKey) && Boolean(token),
  });

  const getTrueLayerBankList = (): TOnlineBank[] => {
    if (!openBankingProviders?.data?.open_banking) return [];

    const openBanking = openBankingProviders.data.open_banking as {
      truelayer_banks?: TOnlineBank[];
      finapi_banks?: TOnlineBank[];
      de_ordered_open_banking_providers?: TOnlineBank[];
    };

    const deOrderedBanks = openBanking.de_ordered_open_banking_providers;
    if (deOrderedBanks && deOrderedBanks.length > 0) {
      return deOrderedBanks.map((bank) => ({
        ...bank,
        provider: inferProvider(bank.bank_id),
      }));
    }

    const truelayerBanks: TOnlineBank[] = (
      openBanking.truelayer_banks || []
    ).map((bank) => ({ ...bank, provider: 'truelayer' as const }));

    const finapiBanks: TOnlineBank[] = (openBanking.finapi_banks || []).map(
      (bank) => ({ ...bank, provider: 'finapi' as const }),
    );

    return [...truelayerBanks, ...finapiBanks];
  };

  return {
    bankList: getTrueLayerBankList(),
    isLoading,
    isError,
  };
}
